<template>
  <div class="hr-input-field-date">
    <co-form-item :label="label" :required="required" :error="error">
      <co-date-picker
        class="__date"
        v-model="state.date"
        popout-direction="left"
        :format="DATE_FORMAT[countryCode] || DATE_FORMAT.default"
        :placeholder="placeholder"
        :disabled-dates="disabledDates"
        typeable
      />
    </co-form-item>
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import { CoDatePicker, CoFormItem } from '@deputy/copilot2';
import { COUNTRY } from '@/core/country';
import { DATE_FORMAT } from '@/core/date-format';

export default {
  name: 'hr-input-date',
  components: {
    CoDatePicker,
    CoFormItem,
  },
  props: {
    date: {
      type: Date,
      default: () => {},
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabledDates: {
      type: Object,
      default: () => {},
    },
    countryCode: {
      type: String,
      default: 'AU',
    },
  },
  emits: ['date-change'],
  setup(props, { emit }) {
    const state = reactive({
      date: computed({
        get: () => props.date,
        set: (newValue) => {
          emit('date-change', newValue);
        },
      }),
    });

    return {
      state,
      COUNTRY,
      DATE_FORMAT,
    };
  },
};
</script>

<style scoped>
:deep(.co-form-item__error) {
  font-size: 14px !important;
}
:deep(.co-form-item) {
  margin-bottom: 0;
}
</style>
